import Config from 'config';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { parseXMLRequestResponse } from '../utils/util';
import { TErrMessage, TRequestError } from './types';

export type TCheckWebDavDocsLocksResponse = {
  onClose: string;
  actions: {
    action: {
      toDo: string;
      param: [string, string];
    };
  };
  sysMessages?: TErrMessage;
  sysException?: TErrMessage;
};

export interface ICheckWebDavDocsLocksSlice {
  onClose: string | null;
  toDo: string | null;
  param: string[] | null;
  response: TCheckWebDavDocsLocksResponse | TRequestError | null;
}

export const fetchWebdavLocks = createAsyncThunk<
  TCheckWebDavDocsLocksResponse,
  null
>('checkWebDavDocsLocksSlice/fetchWebdavLocks', async (_, thunkAPI) => {
  try {
    const response = await axios.post(Config.CHECK_WEB_DAV_DOCUMENTS_LOCKS_URL);
    return parseXMLRequestResponse(response) as TCheckWebDavDocsLocksResponse;
  } catch (err) {
    const error = (err as TRequestError).response;
    return thunkAPI.rejectWithValue(error.data);
  }
});

const checkWebDavDocsLocksSlice = createSlice({
  name: 'checkWebDavDocsLocksSlice',
  initialState: {
    onClose: null,
    toDo: null,
    param: [],
    response: null,
  } as ICheckWebDavDocsLocksSlice,
  reducers: {
    checkWebDavDocsLocksResult: (
      state,
      action: PayloadAction<ICheckWebDavDocsLocksSlice>,
    ) => {
      state.onClose = action.payload.onClose;
      state.toDo = action.payload.toDo;
      state.param = action.payload.param;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchWebdavLocks.pending, (state, action) => {
      if (action.payload) {
        state.response = action.payload;
      }
    });
    builder.addCase(fetchWebdavLocks.fulfilled, (state, action) => {
      if (action.payload) {
        state.response = action.payload;
        state.toDo = action.payload.actions.action.toDo;
        state.param = action.payload.actions.action.param;
        state.onClose = action.payload.onClose;
      }
    });
    builder.addCase(fetchWebdavLocks.rejected, (state, action) => {
      if (action.payload) {
        state.response = action.payload as TRequestError;
      }
    });
  },
});
export default checkWebDavDocsLocksSlice.reducer;
export const { checkWebDavDocsLocksResult } = checkWebDavDocsLocksSlice.actions;
